import React from "react";

import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";

import { useSelector, useDispatch } from "react-redux";

import { Box, Typography } from "@material-ui/core";
import Pagination from "@material-ui/lab/Pagination";
import { animateScroll as scroll } from "react-scroll";
import HubbleRequests from "services/hubble";
import HubbleRefereeTableHeading from "./HubbleRefereeTableHeading";
import HubbleRefereeTableItem from "./HubbleRefereeTableItem";

const HubbleRefereeTable = () => {
  const {
    hubbleReferee,
    hubbleRefereeCurrentPage,
    hubbleRefereeTotalPages,
    selectedJudge
  } = useSelector(({ hubble }) => hubble);
  const dispatch = useDispatch();

  const handleChangePagination = (_, value) => {
    dispatch(HubbleRequests.getHubbleRefereeList(value,selectedJudge));
    scroll.scrollToTop();
  };

  return (
    <div className="Cmt-table-responsive">
      {hubbleReferee && hubbleReferee.length === 0 ? (
        <Box
          display={"flex"}
          justifyContent={"center"}
          paddingTop={"30px"}
          paddingBottom={"20px"}
        >
          <Typography variant="h3">موردی برای نمایش وجود ندارد</Typography>
        </Box>
      ) : (
        <Table>
          <TableHead>
            <HubbleRefereeTableHeading />
          </TableHead>
          <TableBody>
            {hubbleReferee.map((item) => (
              <HubbleRefereeTableItem row={item} key={item._id} />
            ))}
          </TableBody>
        </Table>
      )}
      {hubbleReferee.length !== 0 ? (
        <Box display={"flex"} justifyContent={"center"} marginTop={"20px"}>
          <Pagination
            count={hubbleRefereeTotalPages}
            color="primary"
            page={hubbleRefereeCurrentPage}
            onChange={handleChangePagination}
          />
        </Box>
      ) : null}
    </div>
  );
};

export default HubbleRefereeTable;
